import * as ReactDOM from 'react-dom';
import {unmountComponentAtNode} from 'react-dom';
import Viewpvtvillas from './Viewpvtvillas';
import Viewpublivillas from './Viewpublivillas';
import Villanameshow from './Villanameshow';
import Usersession from './Usersession';
import Villactions from './Villactions';
import {Chtuser} from './Userchat';
import axios from 'axios';
import Configdata from './Defaultdata';
import  Cthmchat from './Chat';
import Register from './Register';
import Registerpin from './Registerpin';
import Signup from './Signup';
import {getsubusr} from './Subusers'; 
import {wrongmsg,getmessage,getstacmessage } from './Dynamictable';
import Createsubuser from './Createsubuser';
import Shoping from './Shoping';
import {getusermsgs} from './Userpvtmsgs';
import UFriends from './UFriends';
import {cleardv} from './clearmem';
import Useritems from './Useritems';
import {GetItemslist} from './Itemslist';
import Viewuseractivities from './Viewuseractivities';
import Viewuserservices from './Viewuserservices';
import {Useraction} from './Useractions';
import Signupandroid from './Signupandroid';
import Pinentry from './Pinentry'; 
import {Uprofile} from './Userprofile'; 
import ReceiverPublicvilla from './socketpublicvilla';
export const multip = (a: any, b: any) => {
  return a * b;
};
export const cityidfromcod = (code: any) => {
  let ctid =0;
  let arrcits = citycodeids;
	
	for(let i =0;i< arrcits.length;i++){
              
                 const rv = arrcits[i];
	         const cv = rv["label"];
 		 if(cv == code){	
		 ctid = rv["value"]; 
		 break;
		} 
		
	}
  return ctid;	
};
export const getcolmvalbykypr = (arrs:any,k: any,v: any,sk: any) => {
  let searchv = '';
 
	
	for(let i =0;i< arrs.length;i++){
              
                 const rv = arrs[i];
	         const cv = rv[k];
 		 if(cv == v){	
		 searchv = rv[sk]; 
		 break;
		} 
		
	}
  return searchv;	
};
export const getcolval = (arrs:any,k: any,v: any) => {
  let searchv = [{}];
 
	
	for(let i =0;i< arrs.length;i++){
              
                 const rv = arrs[i];
	         const cv = rv[k];
 		 if(cv == v){	
		 searchv.push(rv); 
		 
		} 
		
	}
  return searchv;	
};
export const getcolnotval = (arrs:any,k: any,v: any) => {
  let searchv = [{}];
 
	
	for(let i =0;i< arrs.length;i++){
              
                 const rv = arrs[i];
	         const cv = rv[k];
 		 if(cv != v){	
                 searchv.push(rv); 
		 
		} 
		
	}
  return searchv;	
};
 
 
export const  arutyps = [
	
	{ value: 1, label: 'Male' },
	{ value: 0, label: 'Female' }

	

];
export const  arutypsa = [
	{ value: 1, label: 'Male' },
	{ value: 0, label: 'Female' },


];
export const  arutypso = [
	{ value: 1, label: 'Male' },
	{ value: 0, label: 'Female' },
	
	

];

export const  aroffers = [
	{ id: "0", oname: 'No offers available',val:0,units:'' },
	{ id: "1", oname: ' exclusive offer of 10 days free post',val:10,units:'day' },
       
];
export const  getprofileoffer = (oid: any)=>{
	const offrs = aroffers;
        let ofr ="";
	for(let i = 0;i<offrs.length;i++){
	  const ofobj = offrs[i];
          const oval = ofobj["id"];
	  if(oid == oval){
	    ofr = ofobj["oname"];
	     break;
	  }
	}
       return ofr;
};

export const  arrcomptype = [
	{ value: 1, label: 'Proprietorship' },
        
	{ value: 2, label: 'Partnership' },
	{ value: 3, label: 'OPC' },
	{ value: 4, label: 'LLP' },
	{ value: 5, label: 'PVT. Limited' },
	{ value: 6, label: 'Public Limited' },
	{ value: 7, label: 'Non profit Organization' },



];

export const arradvtype = [
{value:1,label:'Mainfullbackground'},
{value:2,label:'Mainhalfbackground'},
{value:3,label:'homefullbackground'},
{value:4,label:'Homehalfbackground'},
{value:5,label:'Searchtop'},
{value:6,label:'Searchmultiple'},
{value:7,label:'Searchcity'},
{value:8,label:'Searchcondition'},
{value:9,label:'Other'},


];

export const citiescodes = [

{ value:'DEH',label:'Dehli'},
{ value:'GUR',label:'Gurgaon'},
{ value:'NAV',label:'Navi mumbai'},
{ value:'MUM',label:'Mumbai'},
{ value:'KOL',label:'Kolkata'},
{ value:'HOW',label:'Howrah'},
{ value:'CHE',label:'Chennai'},
{ value:'HYD',label:'Hyderabad'},
{ value:'BEN',label:'Bengaluru'},
{ value:'AHM',label:'Ahmedabad'},
{ value:'SUR',label:'Surat'},
{ value:'AMR',label:'Amritsar'},
{ value:'BHO',label:'Bhopal'},
{ value:'BHU',label:'Bhubaneswar'},
{ value:'CUT',label:'Cuttack'},
{ value:'CHA',label:'Chandigarh'},
{ value:'FAR',label:'Farvalueabad'},
{ value:'GHA',label:'Ghaziabad'},
{ value:'JAM',label:'Jamshedpur'},
{ value:'JAI',label:'Jaipur'},
{ value:'KOC',label:'Kochi'},
{ value:'LUC',label:'Lucknow'},
{ value:'NAG',label:'Nagpur'},
{ value:'PAT',label:'Patna'},
{ value:'RAI',label:'Raipur'},
{ value:'VIS',label:'Visakhapatnam'},
{ value:'AGR',label:'Agra'},
{ value:'AJM',label:'Ajmer'},
{ value:'KAN',label:'Kanpur'},
{ value:'MYS',label:'Mysore'},
{ value:'SRI',label:'Srinagar'},
{ value:'PUN',label:'Pune'}

];
export const citycodeids = [

{ label:'DEH',value:1},
{ label:'GUR',value:2},
{ label:'NAV',value:3},
{ label:'MUM',value:4},
{ label:'KOL',value:5},
{ label:'HOW',value:6},
{ label:'CHE',value:7},
{ label:'HYD',value:8},
{ label:'BEN',value:9},
{ label:'AHM',value:10},
{ label:'SUR',value:11},
{ label:'AMR',value:12},
{ label:'BHO',value:13},
{ label:'BHU',value:14},
{ label:'CUT',value:15},
{ label:'CHA',value:16},
{ label:'FAR',value:17},
{ label:'GHA',value:18},
{ label:'JAM',value:19},
{ label:'JAI',value:20},
{ label:'KOC',value:21},
{ label:'LUC',value:22},
{ label:'NAG',value:23},
{ label:'PAT',value:24},
{ label:'RAI',value:25},
{ label:'VIS',value:26},
{ label:'AGR',value:27},
{ label:'AJM',value:28},
{ label:'KAN',value:29},
{ label:'MYS',value:30},
{ label:'SRI',value:31},
{ label:'PUN',value:32}

];

export const incities = [
        { value: 0, label: 'Others' },
        { value: 1, label: 'New Dehli' },
        { value: 2, label: 'Gurgaon' },
	 { value: 7, label: 'Chennai' },
        { value: 8, label: 'Hyderabad' },
        { value: 9, label: 'Bengaluru' },
        { value: 3, label: 'Navi Mumbai' },
        { value: 4, label: 'Mumbai' },

        { value: 5, label: 'Kolkata' },
        { value: 6, label: 'Howrah' },
       
        { value: 10, label: 'Ahmedabad' },
        { value: 11, label: 'Surat' },
        { value: 12, label: 'Amritsar' },
        { value: 13, label: 'Bhopal' },
        { value: 14, label: 'Bhubaneswar' },
        { value: 15, label: 'Cuttack' },
        { value: 16, label: 'Chandigarh' },
        { value: 17, label: 'Faridabad' },
        { value: 18, label: 'Ghaziabad' },
        { value: 19, label: 'Jamshedpur' },
        { value: 20, label: 'Jaipur' },
        { value: 21, label: 'Kochi' },
        { value: 22, label: 'Lucknow' },
        { value: 23, label: 'Nagpur' },
        { value: 24, label: 'Patna' },
        { value: 25, label: 'Raipur' },
        { value: 26, label: 'Visakhapatnam' },
        { value: 27, label: 'Agra' },
        { value: 28, label: 'Ajmer' },
        { value: 29, label: 'Kanpur' },
        { value: 30, label: 'Mysore' },
        { value: 31, label: 'Srinagar' },
        { value: 32, label: 'Pune' },
    ];
export const pblcvilas = [
        		{uid:0,villaid:"1",villaname:"Morden",vt:1,ucnt:0},
			{uid:0,villaid:"2",villaname:"Village",vt:1,ucnt:0},
			{uid:0,villaid:"3",villaname:"Nature",vt:1,ucnt:0},
			{uid:0,villaid:"4",villaname:"Altra Morden",vt:1,ucnt:0},
			{uid:0,villaid:"5",villaname:"Urban",vt:1,ucnt:0},
			{uid:0,villaid:"6",villaname:"Clasical",vt:1,ucnt:0},
			{uid:0,villaid:"7",villaname:"Science",vt:1,ucnt:0},
			{uid:0,villaid:"8",villaname:"Health",vt:1,ucnt:0},
			{uid:0,villaid:"9",villaname:"Cultural",vt:1,ucnt:0},
			{uid:0,villaid:"10",villaname:"Learning",vt:1,ucnt:0},

    			];
export const onfigpblvl=(arr:any)=>{
 let arrs =[];
   for(let i =0;i< arr.length;i++){
                let obj = {uid:0,villaid:"0",villaname:"Learning",vt:1,ucnt:0};
                 const rv = arr[i];
	         obj["uid"] = rv["uid"];
		 obj["villaid"] = rv["villaid"];
		obj["villaname"] = rv["villaname"];
		obj["vt"] = rv["vt"];
		obj["ucnt"] = rv["ucnt"];
	
                 arrs.push(obj); 
	
		
	}
	Usersession.setPubvillas(arrs);
}
export const gtpblvl=()=>{
           	Usersession.setPubvillas(pblcvilas);

   //try {

	//let  service ="/getpublicvillalst";
     
	//axios.get(Configdata.srvurl + service)
       //     .then((response: any) => {             
	//	const tdata = response.data;
        //        onfigpblvl(tdata);
        //    })
        //    .catch((err: any) => { });
        //  }
        //catch (e) { }
  
};

export const showhidediv=(ishide:any,id:any)=>{
const dv = document.getElementById(id) as HTMLElement;
if(dv){
if(ishide)dv.style.display = 'none';
else dv.style.display = 'block';
}
};

export const loadwidgate=(id:any,wid:any)=>{
const dv = document.getElementById(id) as HTMLElement;
if(dv){
dv.style.display = 'block';

if(wid == 2){
	if(cleardv(id)){
	const pvtvla = <Viewpvtvillas />
	ReactDOM.render(pvtvla,dv);
	}
     }
else if(wid == 1){
	if(cleardv(id)){
	const pvtvla = <Viewpublivillas />
	ReactDOM.render(pvtvla,dv);
	}
     }
else if(wid == 3){
         

	if(cleardv(id)){
        
	const pvtvla = <Villanameshow />
	ReactDOM.render(pvtvla,dv);
	}
     }
else if(wid == 4){
         

	if(cleardv(id)){
        
	const villa = <Villactions />
	ReactDOM.render(villa,dv);
	}

     }
else if(wid == 5){
         
     
	if(cleardv(id)){
       
	const pvtvla = <Cthmchat />
	ReactDOM.render(pvtvla,dv);
	}
     }
else if(wid == 6){
        

	if(cleardv(id)){
         
         const dv = document.getElementById(id) as HTMLElement;
         dv.style.display = 'block';
         
	const pvtvla = <Registerpin />;
	ReactDOM.render(pvtvla,dv);
	}
     }
    
else if(wid == 7){
        

	if(cleardv(id)){
          
         const dv = document.getElementById(id) as HTMLElement;
         dv.style.display = 'block';
         
	const pvtvla = <Register />;
	ReactDOM.render(pvtvla,dv);
	}
     }

else if(wid == 8){
        

	if(cleardv(id)){
          
         const dv = document.getElementById(id) as HTMLElement;
         dv.style.display = 'block';
         
	const pvtvla = <Signupandroid />;
	ReactDOM.render(pvtvla,dv);
	}
     }
else if(wid == 9){
        

	if(cleardv(id)){
         // alert('ok');
         const dv = document.getElementById(id) as HTMLElement;
         dv.style.display = 'block';
         
	const pvtvla = <Createsubuser />;
	ReactDOM.render(pvtvla,dv);
	}
     }
else if(wid == 10){
        

	if(cleardv(id)){
         // alert('ok');
         const dv = document.getElementById(id) as HTMLElement;
         dv.style.display = 'block';
         
	const pvtvla = <Shoping />;
	ReactDOM.render(pvtvla,dv);
	}
     }
else if(wid == 11){
        

	if(cleardv(id)){
         // alert('ok');
         const dv = document.getElementById(id) as HTMLElement;
         dv.style.display = 'block';
         
	const pvtvla = <UFriends />;
	ReactDOM.render(pvtvla,dv);
	}
     }

else if(wid == 12){
        

	if(cleardv(id)){
         // alert('ok');
         const dv = document.getElementById(id) as HTMLElement;
         dv.style.display = 'block';
         
	const itms = <Useritems />;
	ReactDOM.render(itms,dv);
	}
     }
else if(wid == 13){
        

	if(cleardv(id)){
         // alert('ok');
         const dv = document.getElementById(id) as HTMLElement;
         dv.style.display = 'block';
         
	const act = <Viewuseractivities />;
	ReactDOM.render(act,dv);
	}
     }
else if(wid == 14){
        

	if(cleardv(id)){
         // alert('ok');
         const dv = document.getElementById(id) as HTMLElement;
         dv.style.display = 'block';
         
	const srv = <Viewuserservices />;
	ReactDOM.render(srv,dv);
	}
     }
else if(wid == 15){
        

	if(cleardv(id)){
         // alert('ok');
         const dv = document.getElementById(id) as HTMLElement;
         dv.style.display = 'block';
         
	const sin = <Signup />;
	ReactDOM.render(sin,dv);
	}
     }
else if(wid == 16){
        

	if(cleardv(id)){
         // alert('ok');
         const dv = document.getElementById(id) as HTMLElement;
         dv.style.display = 'block';
         
	const Pine = <Pinentry />;
	ReactDOM.render(Pine,dv);
	}
     }
else if(wid == 17){
        

	if(cleardv(id)){
         const dv = document.getElementById(id) as HTMLElement;
         dv.style.display = 'block';
         
	}
     }
else if(wid == 18){
        

	if(cleardv(id)){
         // alert('ok');
         const dv = document.getElementById(id) as HTMLElement;
         dv.style.display = 'block';
         
	const publicvla = <ReceiverPublicvilla />;
	ReactDOM.render(publicvla,dv);
	}
     }

   }
};

export const clrwidgate=(id:any)=>{
	if(cleardv(id)) showhidediv(true,id);
};
export const stvlsn=(id:any,data:any)=>{
	Usersession.setVillaname(data);
	Usersession.setVillaId(id);

};
export const msgalw=(sid:any,rid:any,tp:any)=>{
       // alert(tp);
        let alw = 'User not allowed';
        if(tp == 0){
	return 'OK';
	}
	else if(tp == 2){
	 return 'User not allowed';
	}
	else if(tp == 1){
	 return chkfrnd(sid,rid);
	}
    return alw;
};
export const chkfrnd=(sid:any,rcvid:any)=>{
         let alw = 'User not allowed';

	 try {
  
	let  service ="/checkfriend?sid="+sid+"&rid="+rcvid;
	axios.get(Configdata.srvurl + service)
            .then((response: any) => {
		const tdata = response.data;
                return tdata;
            })
            .catch((err: any) => {
            
            });

          }
        catch (e) {
	
        }
	return alw;
}
export const gtdfltvid=(id:any)=>{
	let searchv = {uid:0,villaid:"1",villaname:"Morden",vt:1,ucnt:20};

        var arrs = Usersession.getPubvillas();
	let search = false;
	for(let i =0;i< arrs.length;i++){
              
                 const rv = arrs[i];
	         if(rv.villaid == id && rv.ucnt < 20){
		   searchv =  arrs[i];
		   search = true;	
		   break;

		}
 		
		
	}
        if(!search){
	  for(let i =0;i< arrs.length;i++){
              
                 const rv = arrs[i];
	         if(rv.ucnt < 20){	
		 searchv =  arrs[i];
		 break;
		 
		} 
		

	}
   }
  return searchv;	

}
export const gtdfltvidpvt=(id:any)=>{
	let searchv = {uid:0,villaid:"1",villaname:"Morden",vt:1,ucnt:20};

        var arrs = Usersession.getPubvillas();
	let search = false;
	for(let i =0;i< arrs.length;i++){
              
                 const rv = arrs[i];
	         if(rv.villaid == id && rv.ucnt < 20){
		   searchv =  arrs[i];
		   search = true;	
		   break;

		}
 		
		
	}
        if(!search){
	  for(let i =0;i< arrs.length;i++){
              
                 const rv = arrs[i];
	         if(rv.ucnt < 20){	
		 searchv =  arrs[i];
		 break;
		 
		} 
		

	}
   }
  return searchv;	

}

export const setdvl=()=>{
     var dvl = {uid:0,villaid:"1",villaname:"Morden",vt:1,ucnt:20};
     //const dvid = localStorage.getItem("dvillaid");
     //const vtpid = localStorage.getItem("vilaty");
    
    const dvid = Usersession.getVillaId();
     const vtpid =  Usersession.getVillatype();

     
         
        if(dvid){
         let tvid = dvid;
         if(tvid > 0){
          if(vtpid == '1' || vtpid == null) dvl = gtdfltvid(dvid);
	  else 	dvl = gtdfltvidpvt(dvid);
         }
     	else  dvl = gtdfltvid('0');
	}
       
       
        const vid = dvl.villaid;
        const vnm = dvl.villaname;
        const uvt = dvl.vt;
	//localStorage.setItem("dvillaid", vid);
        
	Usersession.setVillaname(vnm);
	Usersession.setVillaId(vid);
        const villaid = vid;
    // entervilla(vid,vnm,entervilla,vtpid);
	
}
export const stemoj=(emoji:any)=>{
	const ctb = document.getElementById('ctxt') as HTMLInputElement;
        const ctbmsg = document.getElementById('msgctxt') as HTMLInputElement;
 
         const ismsgentry = Usersession.getEmojchat();
        

 	if(!ismsgentry){
		if(ctb){
            		ctb.value += emoji;
            
        	}
	}
        else{
		if(ctbmsg){
            		ctbmsg.value += emoji;
            		

        	}


	}

};

export const openemoji=(isopen:any)=>{
const dv = document.getElementById('emojiarea') as HTMLElement;
if(isopen) dv.style.display = 'block';
else dv.style.display = 'none';

};
export const stcolor=(code:any)=>{
	Usersession.setColorcode(code);

};
export const gtvlacht=(id:any,tp:any)=>{
	//Usersession.setColorcode(code);
	//getmsgdata(id,tp);
        //Loadvillachat();
      //  alert(tp);
         //Villachatwidg(tp);
};
export const configchat=(arr:any)=>{
 const currenthat = Usersession.getVillachat();
 //alert(JSON.stringify(arr));

if(currenthat.length <  arr.length || currenthat.length >= 29 || currenthat.length == 0)
 Usersession.setVillachat(arr);

  Usersession.setSubuserstatus(0);


Loadvillachat();

};
export const Villachatwidg=(vt:any)=>{
//alert(vt);
  if(vt=='2')
 loadwidgate('usrchatarea',17);
else
  loadwidgate('usrchatarea',18);
   scrolldowncboat('chatscrollarea');
 
};

export const Loadvillachat=()=>{
 const arr = Usersession.getVillachat();
 var isenter = Configdata.ischatscroll;
 const chats = Chtuser(arr);
 //alert(JSON.stringify(arr));
// if(cleardv('usrchatarea')){
  const dv = document.getElementById('usrchatarea') as HTMLElement;
  if(arr.length > 0)
  ReactDOM.render(chats,dv);
  if(isenter)
   scrolldowncboat('chatscrollarea');
 //}
};


export const arrengvdata=(arr:any)=>{
		let pblcvls =[{uid:0,villaid:"10",villaname:"Learning",vt:1,ucnt:0}]; 
                  let searchv = [{}];
 		  pblcvls = arr;
	
	for(let i =0;i< arr.length;i++){
                let obj = {uid:0,villaid:"10",villaname:"Learning",vt:1,ucnt:0};
                 const rv = arr[i];
	         obj["uid"] = rv["uid"];
		 obj["villaid"] = rv["villaid"];
		obj["villaname"] = rv["villaname"];
		obj["vt"] = rv["vt"];
		obj["ucnt"] = rv["ucnt"];
	
                 searchv.push(obj); 
	
		
	}
  return searchv;	


 
};
export const arrengeobj=(trow:any,srow:any)=>{
		
                let obj = {pfpid:3,age:20,utf:true,uname:'userguest',points:10,utpid:0,dob:"",id:0,msgalow:0};
		obj = srow;
              let rv = {mid:0,mpid:0,mupoints:0,mofferid:0,muname:"",mudob:"",mutypeid:0,upfpid:0,isf:'',msgalow:0};
		 
                if(trow)  rv = trow;
                 
		//alert(JSON.stringify(rv));
                	
	         obj["pfpid"] = rv["upfpid"];
		 obj["uname"] = rv["muname"];
		 obj["points"] = rv["mupoints"];
		 obj["utpid"] = rv["mutypeid"];
		 obj["dob"] = rv["mudob"];
		// obj["id"] = rv["mid"];
		 obj["utf"] = rv["isf"]=="0"?false:true;
		obj["msgalow"] = rv["msgalow"];

                
	
		
	
  return obj;	


 
};

export const getmsgdata=(id:any,vltp:any)=>{
	 try {
        
	const vid = id;

         const userid = Usersession.getUserId();
       
	//const vtype = Usersession.getVillatype();
	let  service ="/getchatmsg?cid="+vid+"&uid="+userid;
        if(vltp == '2')
	 service ="/getchatmsgp?cid="+vid+"&uid="+userid;
       // alert(service);
	axios.get(Configdata.srvurl + service)
            .then((response: any) => {
              
		const tdata = response.data;
                //alert(JSON.stringify(tdata));
		configchat(tdata);
		
            })
            .catch((err: any) => {
            
            });

                
          }
        catch (e) {
            //debugger;
	
        }

	
     };	
export const  getsid=()=>{
const suid = gets('Superuserid');
let sid = 0;
if(suid)
{
  sid = parseInt(suid);
 if(sid > 0) return sid;

}
return sid;
}
export const  getpin=()=>{
const upin = gets('Userpin');
let pin = 0;
if(upin)
{
  pin = parseInt(upin);
 if(pin > 0) return pin;

}
return pin;
}

export const  sets=(sid:any,upin:any,unam:any,uid:any)=>{
               // alert(sid);
		if(sid != 'NA'){
                localStorage.setItem('Superuserid',sid);
                  
	       }
                if(upin != 'NA')
 		localStorage.setItem('Userpin',upin);
                if(unam != 'NA'){
                           
		 localStorage.setItem('Username',unam);
                Usersession.setCode(unam);
                
    		}
		if(uid != 'NA')
    		Usersession.setUserId(uid)
     }
export const  gets=(snam:any)=>{
             const value =  localStorage.getItem(snam);
            // alert(value);
 		return value;

     }
 export const  hdactinf=()=>{
  showhidediv(true,'ntifact');
   showhidediv(true,'lstact');
   showhidediv(true,'Activitynotify');



 };

export const  getloginuser=(userinfo:any)=>{
	 try {
	        let url = '';
		const suserid = userinfo.split('-')[1];	
		const usernm = userinfo.split('-')[0];	
		let upin = '0';
                showdelay();
		if(userinfo.split('-').length > 2) upin = userinfo.split('-')[2];
               
                const response = axios.post(Configdata.srvurl + '/getloginusers', {
    		uid: suserid
    		
  		}, {
    		    headers: {
      				'Content-Type': 'application/json'
    			      }
  			}
		);
	      
                if(response){
		 response.then((result:any) => {
		const usercd = result.data;
               // alert('3');

                sets(suserid,upin,usernm,"NA");
               // alert(JSON.stringify(usercd));
		setlogininfo(usercd);	
		 closedelay();
		
	        });		
              
	     }
	   }
         
        catch (ex:any) {
                 closedelay();

           // debugger;
		wrongmsg();
        }
};
export const  setsubusers=()=>{
     //   showhidediv(true,'container');
	
         const dv = document.getElementById('Subusdv') as HTMLElement;
       showhidediv(false,'Subusdv');

        const arr = Usersession.getsubusers();
        const sbusers = getsubusr(arr);
         ReactDOM.render(sbusers,dv);
}

export const  setlogininfo=(users:any)=>{
	
	//alert(JSON.stringify(users));
         const dv = document.getElementById('container') as HTMLElement;
        const arr = setsbusrarr(users);
        const sbusers = getsubusr(arr);
        Usersession.setsubusers(arr);
	//alert(JSON.stringify(users[0]));
	
        ReactDOM.render(sbusers,dv);
	//loadwidgate('container',5);
}
export const  setsbusrarr=(users:any)=>{
	
	let subusrs = [{mid:0, mpid:0, mupoints:0, mofferid:0,muname:"", mudob:"",mutypeid:0,upfpid:0}];
	for(let i =0;i< users.length;i++){
	  const arobj = users[i][0];
	  subusrs.push(arobj);
	}
    subusrs.splice(0,1);
  // alert(JSON.stringify(subusrs));
   return subusrs;
};
export const  rvmr=(arrs:any)=>{
	
	let arr = [{}];
       
	for(let i =0;i< arrs.length;i++){
	  const arobj = arrs[i][0];
	  arr.push(arobj);
	}
   if(arr.length > 1)
    arr.splice(0,1);
  // alert(JSON.stringify(subusrs));
   return arr;
};
export const  setbkc=(id:any,cn:any)=>{
	const dv = document.getElementById(id) as HTMLElement;
	if(dv)dv.style.backgroundColor= cn;
}
export const  insertpost=(url:any,jsondata:any)=>{
        //alert(JSON.stringify(jsondata));
        let responddata = 'NA';
	 try {
	        
		
                const response = axios.post(Configdata.srvurl + url,jsondata, {
    		    headers: {
      				'Content-Type': 'application/json'
    			      }
  			}
		);
	      
                if(response){
		 response.then((result:any) => {
		const usercd = result.data;
                responddata = usercd;	
                //alert(JSON.stringify(responddata));
                if(responddata != 'NA')
		getmessage(responddata,'');	
	        });		
              
	     }
	   }
         
        catch (ex:any) {
           // debugger;
	//	wrongmsg();
        }
       return responddata;
};
export const  fillmsg=(arr:any,isentry:any)=>{
  if(arr.length > 0){
 // alert(JSON.stringify(arr));
  const msgarr = rvmr(arr);

   const setmsgdiv = getusermsgs(msgarr);
     const dv = document.getElementById('usrpvtmsgarea') as HTMLElement;
      if(dv){
       if(cleardv('usrpvtmsgarea')){
        
         dv.style.display = 'block';
  	//alert(dv.innerHTML);
	ReactDOM.render(setmsgdiv,dv);
         if(isentry)
           scrolldowncboat('pvtmsgareascrol');


	}
	}
  }
}

export const hopitems=(opt:any,tp:any)=>{

	 try {
         //const vid = localStorage.getItem("dvillaid");
	
         
	let  service ="/getchtitems?oprd="+opt+"&tprd="+tp;

        	//alert(service);
	axios.get(Configdata.srvurl + service)
            .then((response: any) => {
              

		const tdata = response.data;
               // alert(JSON.stringify(tdata));
		reducearr(tdata);
                
            })
            .catch((err: any) => {
            
            });

                
          }
        catch (e) {
            //debugger;
	
        }

	
     }
    export const reducearr=(arr:any)=>{
       let data = JSON.stringify(arr);
       // alert(data);
	let farr = [
		{
		mid:0,mitemname: 'Test',mitemurl:'',mextention:'',mitemtype: 1,msts: 0,mpointdeduct: 2,mitxt:""
		},
		   ]

	 if(arr){
	     if(arr.length > 0){
              
		for(let i =0;i< arr.length;i++){
               
                 const rv = arr[i];
                
		// const uv = rv["mitemurl"];
                 //rv["mitemurl"] = uv;
                
		 farr.push(rv);
		 
		}
	    }
	 }
	if(farr.length > 1){
	 farr.shift();
	}
       const dv = document.getElementById('ushopitems') as HTMLElement;
 	 if(dv){
            // alert(JSON.stringify(farr));
	    const gtitems = GetItemslist(farr);	
	     ReactDOM.render(gtitems,dv);

	}
     }

export const Exituser=()=>{
  //sets('79','NA','testuser','NA');
      const removevillaid =Usersession.getVillaId();

        const userpin = Usersession.getUserpin(); 
	const superid = getsid();
        const tempsubusers =[[{mid:1, mpid:superid, mupoints:10, mofferid:0,muname:"testuser", mudob:"1999-07-02",mutypeid:0,upfpid:0}]];
	 const uinfo = 'NA-'+ superid+'-'+userpin;
         const userid = Usersession.getUserId();
         //alert(userid);

        const apurl = '/removechatusrs';
        const obj = {uid: userid};
         insertpost(apurl,obj);
	// getloginuser(uinfo);
	setsubusers();
        Usersession.setSubuserstatus(1);
        setdefaulvillachat();
        usermoved(0,removevillaid);
        //hideemoji();

}
export const  changeback=(e:any,col:any)=>{
	  e.target.style.backgroundColor = col;

};
export const  chngbackbyid=(id:any,col:any)=>{
	 const dv = document.getElementById(id) as HTMLElement;
 	if(dv){
		dv.style.backgroundColor = col;
	}

};
export const  runtimerchatmsg=()=>{
    
          const id = Usersession.getVillaId();
         const vtpid =  Usersession.getVillatype();
          const tp = parseInt(vtpid);
	 
          if(id > 0 && tp > 0){
       
       
	  setusersinactiondv(id,false);

          getmsgdata(id,vtpid);


          Loadvillachat();
	 // gtpblvl();
        }
   
};
export const  getonlinests=()=>{
        var isactive = true;
      try {
         const userid = Usersession.getUserId();
 	var  service ="/getonlineusersts?uid="+userid;
        //alert(service);
	axios.get(Configdata.srvurl + service)
            .then((response: any) => {
        	const tdata = response.data;
                const tval = JSON.stringify(tdata)
               
               if(tdata.csts != 1){
             
		runtimerchatmsg();
		//runmsgs();
		}
        	else{
	              Usersession.setVillaId(0);
	    	      Exituser();	
                     return false;
                } 
               
             })
            .catch((err: any) => {
            
            });

                
          }
        catch (e) {
            //debugger;
	
        }
      
       return isactive;
};

export const  bootdown=()=>{

}
export const  runtimerjob=(isrun:any)=>{
 

   let interval = setInterval(() => {
    const uonlinests =  Usersession.getSubuserstatus();
      //alert(uonlinests);
     if(uonlinests == 0){
       runtimerchatmsg();
       //const isactive = getonlinests();
	//if(!isactive) clearInterval(interval);
      }
      else{
	clearInterval(interval);

       }
      }, 1000);
    

    if(!isrun){
	clearInterval(interval);

    }
 
};
export const runmsgs=()=>{
const rid = Usersession.getRcvmsguserid();
const userid = Usersession.getUserId();

const msgalwid = Usersession.getAlllowmsgId();
const isalow = msgalw(rid,userid,msgalwid);
if(isalow=="OK"){

const dvu = document.getElementById('usrwidgt') as HTMLElement;
// if(dvu)
// cleardv('usrwidgt');

const apimsgurl = '/getpvtmsgroom';
//alert(userid);
//alert(rid);
const obj = {sendid:userid,receiveid:rid};

getumsg(apimsgurl,obj);
}
else{
getmessage(isalow,'');

}

};
export const setusersinactiondv=(vlid:any,isremove:any)=>{
 try {
        
	const vid = vlid;

         const userid = Usersession.getUserId();
         
	const vtype = Usersession.getVillatype();
        
	var  service ="/addvillauser?vid="+vid+"&tid="+vtype+"&uid="+userid;
       if(isremove) service ="/getvillausers?vid="+vid+"&tid="+vtype+"&uid="+userid;

         //alert(service);
       
	axios.get(Configdata.srvurl + service)
            .then((response: any) => {
               

		const tdata = response.data;
                //alert(JSON.stringify(tdata));

		addpfptosession(tdata);
                setuseraction(vid,tdata);
	       if(!isremove)
                 usermoved(vid,0);

		
            })
            .catch((err: any) => {
            
            });

                
          }
        catch (e) {
            //debugger;
	
        }


}
export const addpfptosession=(arr:any)=>{
        var pfparr = [{uid:0,pfpid:1,utf:true,uname:'Rijim',x:'200px',y:'100px'}];
      if(arr.length > 0){
	for(var i = 0;i<arr.length;i++)
       {
          	var obj = {uid:0,pfpid:1,utf:true,uname:'Rijim',x:'200px',y:'100px'};

           const objr = arr[i];
            obj['uid'] = objr['uid'];
            obj['pfpid'] = objr['pfpid'];
            obj['utf'] = objr['utf'];
            obj['uname'] = objr['uname'];
            obj['x'] = objr['x'];
            obj['y'] = objr['y'];
           
          pfparr.push(obj);
       }	
       } 
       if(pfparr.length > 1)	 pfparr.shift();

        Usersession.setVillapfps(pfparr);  
        //alert(JSON.stringify(pfparr));

};

export const setuseraction=(id:any,arr:any)=>{
  const arrv =  Usersession.getVillapfps();
  //alert(JSON.stringify(arrv));
  
  const seen = new Set();
const uniquearr= arrv.filter((item:any) => {
  const isDuplicate = seen.has(item.uid);
  seen.add(item.uid);
  return !isDuplicate;
});
 const actions = Useraction(id,uniquearr);
 if(cleardv('useractions')){
  const dv = document.getElementById('useractions') as HTMLElement;
  ReactDOM.render(actions,dv);

 }
};
export const authuloged=(cmail:any,cpin:any,tp:any)=>{
       let apurl ='/loginbymailpin';
       let obj = {uemail:cmail,mpin:cpin}
       if(tp=="mailcd")	  apurl ='/loginbymailcode';
    	
 	//alert(cpin);
	 try {
                const response = axios.post(Configdata.srvurl + apurl,obj, {
    		    headers: {
      				'Content-Type': 'application/json'
    			      }
  			}
		);
                if(response){
		 response.then((result:any) => {
		const usercd = result.data;
                if(tp=="mailcd"){ 
                const pin = usercd.split('-')[2];
                sets("NA",pin,"NA","NA")
                getstacmessage('PIN is :',pin)
		}
                if(usercd !='NA') 
 		getloginuser(usercd);	
                else{
		getmessage('Something went wrong','')
		}
	        });		
              
	     }
	   }
         
        catch (ex:any) { }
     

}
 export const chkucode=()=>{
	const ucode = Usersession.getCode();	
        if(ucode == "")loadwidgate('container',7); 
        else if(ucode == "NA")loadwidgate('container',15);
    }

 export const getumsg=(url:any,jsondata:any)=>{
        
	 try {
	        
		
                const response = axios.post(Configdata.srvurl + url,jsondata, {
    		    headers: {
      				'Content-Type': 'application/json'
    			      }
  			}
		);
	      
                if(response){
		 response.then((result:any) => {
		const usercd = result.data;
                fillmsg(usercd,false);
                //let responddata = JSON.stringify(usercd);	
		//alert(responddata);	
	        });		
              
	     }
	   }
         
        catch (ex:any) {
           // debugger;
		//wrongmsg();
        }
      
};
export const scrolldowncboat=(divid:any)=>{
if(divid){
const buffer = document.getElementById(divid) as HTMLElement;
if(buffer){

 buffer.scrollTop = buffer.scrollHeight;
}
}

}

export const entervilla=(id:any,vnm:any,vlid:any,vtid:any)=>{
        clrwidgate('wigtarea');
  	Usersession.setVillatype(vtid);
        Usersession.setVillaname(vnm);
	Usersession.setVillaId(id);
       Usersession.setSubuserstatus(0);
        stvlsn(id,vnm);
 	loadwidgate('vilnm',3);
        
	loadwidgate('cbmaindiv',4);
        
  
       //gtvlacht(vlid,vtid);
      
      //  usermoved();

	
}

export const showdelay=()=>{
                showhidediv(true,'container');	
		showhidediv(false,'delayprocess');
               //alert('test');	
}
export const closedelay=()=>{
                showhidediv(false,'container');	
		showhidediv(true,'delayprocess');	
           //   alert('closer');	

}
export const setdefaulvillachat=()=>{
             var villachats = [
		 {uid:0,msg:'',pfpid:0,utid:0,uname:'',code:'#ffff',utype:true},
		 
		];
                Usersession.setVillachat(villachats);


}

export const showprofile=(e:any,rw:any)=>{
 //alert(id);
 const row = rw;
 
 //showhidediv(svt,'chatprofiledivtop');
 const upfp = Uprofile(row);
  Usersession.setRecvactid(row.uid);
 const dv = document.getElementById('usrwidgt') as HTMLElement;
 cleardv('usrwidgt');
 if(dv){
  dv.style.display = 'block';
   ReactDOM.render(upfp,dv);

  }
};
export const reload=(arr:any)=>{
 const actions = Useraction(0,arr);
 if(cleardv('useractions')){
  const dv = document.getElementById('useractions') as HTMLElement;
  ReactDOM.render(actions,dv);

 }

}

export const villachanged=()=>{
         Usersession.setVumsg('NA');
  	const btnsend = document.getElementById('btnsendmsgtosrv') as HTMLInputElement;
       if(btnsend) btnsend.click();

}
export const usermoved=(addvillaid:any,removevillaid:any)=>{

         const addremove = {add:addvillaid,remove:removevillaid};
          Usersession.setVilladdremv(addremove);
        //alert('tst');
  	const btnsend = document.getElementById('btnchangevilla') as HTMLInputElement;
       if(btnsend) btnsend.click();

}
export const  removeusers=(arr:any,userid:any)=>{
    // const  fltrarr =   arr.filter((item:any) => { item.mid!=userid});
     var updatearr = [{}];
      if(arr.length > 0){
     for(var i=0; i<arr.length;i++)
    {
       const obj = arr[i];
       if(obj['mid'] != userid)updatearr.push(obj);
    }
    }
     return updatearr;
}

export const hideemoji=()=>{
showhidediv(true,'btnchatemojidv');
showhidediv(true,'btnenterchatdv');
}
export const showemoji=()=>{
showhidediv(false,'btnchatemojidv');
showhidediv(false,'btnenterchatdv');
}


